import React, { useContext } from 'react'

import Grid from '@mui/material/Grid'
import useProduct from '@/lib/hook/useProduct'
import ProductAddPad from '@/components/Product/ProductAddPad'
import InviteBox from '@/components/InviteBox'
import FONTS from '@/src/fonts'
import COLORS from '@/src/colors'
import ProfileContext from '@/components/Context/ProfileContext'
import getProductPrice from '@/lib/getProductPrice'
import Box from '@mui/material/Box'
import ProductInformationBlock from './ProductInformationBlock'
import ProductCompany from '@/components/Product/ProductCompany'
import ProductShippingInfosResume from '@/components/Product/ProductShippingInfosResume'
import Card from '../Common/Card'
import BrandNameLink from '@/components/Brands/BrandNameLink'
import SETTINGS from '@/src/settings'
import PrecommandeInfo from '@/components/Product/PrecommandeInfo'

export const useStyleProductResume = (_props?: any) => ({
  productName: 'font-semibold text-2xl',
  ean: 'italic text-left text-xs min-h-[10px]',
  eanStyle: { color: COLORS.loveWhilistSvg },
  line: 'flex flex-row items-center content-center justify-between',
  rootInfoProduct: 'text-center flex justify-center content-center items-center cursor-default',
  svgInfoProduct: 'flex justify-center items-center',
  infoProduct: 'ml-2 font-bold',
})

type Props = {
  slug: string
  productId?: string
  scrollToCard?: () => void
  skeyProduct?: string
}

const ProductResume: React.FC<Props> = ({ slug, productId, scrollToCard, skeyProduct }) => {
  const { product } = useProduct(slug, productId, skeyProduct)

  const { isAuthenticated } = useContext(ProfileContext)

  if (isAuthenticated === null || !product) return null

  const { isPromotion, promotionLimited } = getProductPrice(product, 1)

  const brandInfo = product.product_features?.find(
    attr => attr.feature_id === SETTINGS.attributesCodeUse.brandId
  )

  return (
    <div className="w-full">
      <Card elevate smallRadius>
        <Grid container>
          <Grid item xs={12} sm={8}>
            <BrandNameLink product={product} />
            <div className="font-bold text-2xl">{product.product}</div>
            <div
              className="italic text-left text-xs min-h-[10px]"
              style={{ color: COLORS.loveWhilistSvg }}
            >
              {product.product_code ? `EAN : ${product.product_code}` : ''}
            </div>
            {/*<AverageRating rating={product.averageRating} numberOfComments={reviews.length} />*/}
            <div dangerouslySetInnerHTML={{ __html: product.short_description }} />
            {brandInfo?.meta_description && <br />}
            <div
              style={{ fontStyle: 'italic', fontWeight: FONTS.WEIGHT.BOLD }}
              dangerouslySetInnerHTML={{ __html: brandInfo?.meta_description }}
            />
            <br />
            <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'start' } }}>
              <span
                onClick={scrollToCard}
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: COLORS.grayText || '#213390',
                  fontWeight: FONTS.WEIGHT.BOLD,
                }}
              >
                En savoir +
              </span>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className="float-right">
              <ProductInformationBlock
                product={product}
                isPromotion={isPromotion}
                promotionLimited={promotionLimited}
              />
            </div>
          </Grid>
        </Grid>

        <br />

        {product.precommande === 'Y' && (
          <div className="mb-3">
            <PrecommandeInfo availSince={product.avail_since} />
          </div>
        )}

        {isAuthenticated || !!skeyProduct ? <ProductAddPad product={product} /> : <InviteBox />}
      </Card>

      <ProductCompany product={product} />

      <ProductShippingInfosResume product={product} />
    </div>
  )
}

export default ProductResume
